// @author jonathan.ronsten@svenskaspel.se

import type { PropsWithChildren, ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponRowProps = PropsWithChildren<{
  className?: string;
  dataTestId?: string;
  drawNumber?: number;
  isSelected?: boolean;
}>;

/**
 * A coupon row.
 *
 * @param root0 input props
 * @param root0.children react nodes to pass down
 * @param root0.className styles to apply to the parent
 * @param root0.dataTestId data-testid used for testing?
 * @param root0.isSelected optional boolean to indicate if the row is selected, used for styling
 * @returns Component.
 */
export default function CouponRow({ children, className, dataTestId, isSelected }: CouponRowProps): ReactNode {
  return (
    <div
      className={cn(
        'relative p-2 first:pt-6 lg:p-4',
        isSelected
          ? 'lg:before:bg-primary lg:before:absolute lg:before:top-0 lg:before:left-0 lg:before:h-full lg:before:w-1.5'
          : '',
        className
      )}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
}
